import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-brand-icon',
  templateUrl: './brand-icon.component.html',
  styleUrls: ['./brand-icon.component.scss']
})
export class BrandIconComponent {
  @Input() title: string = 'Seller Rewards';
  @Input() showTitle: boolean = true;

  @Output() logoClick = new EventEmitter<void>();

  onLogoClick(): void {
    this.logoClick.emit();
  }
}
